import React, { ReactNode } from 'react'
import clsx from 'clsx'

export const roundedClasses = {
  full: 'rounded-full',
  xl: 'rounded-xl',
  md: 'rounded-md',
  lg: 'rounded-lg',
  sm: 'rounded-sm',
  xs: 'rounded-xs',
} as const

type RoundedType = keyof typeof roundedClasses

interface PillProps {
  children: ReactNode
  fit?: boolean
  backgroundColor?: string
  roundedType?: RoundedType
}

const Pill: React.FC<PillProps> = ({
  backgroundColor = 'bg-neutral-10-background',
  roundedType = 'full',
  fit = false,
  children,
}) => {
  return (
    <div
      className={clsx(
        'inline-flex items-center px-3 py-1',
        roundedClasses[roundedType],
        backgroundColor,
        { 'h-fit': fit },
      )}
      role="status"
    >
      {children}
    </div>
  )
}

export default Pill
